import _ from 'lodash';

import { ROW_HEIGHT_PX } from './FormGeneratorRichTextEditor.constants';

export const getMinHeight = rows => (_.isNil(rows) ? null : rows * ROW_HEIGHT_PX);
